import { useMemo } from 'react'
import { aCardsCollapse, aFiltersPinned, useAtomValue } from '~/atoms'
import { useBreakpoint } from '~/hooks'

const DOUBLE_CARDS = 732
const SINGLE_CARDS = 382
const FILTER_SHEET = 384

export default function useMapCardSizes() {
  const cardsCollapse = useAtomValue(aCardsCollapse)
  const filtersPinned = useAtomValue(aFiltersPinned)
  const { lgDown, mdDown, xlDown } = useBreakpoint()

  const sizes = useMemo(() => {
    // Single depreciated and also fixed now
    const single = 484
    const filters = filtersPinned && !lgDown ? FILTER_SHEET : 0
    if (cardsCollapse === 'none' || mdDown) {
      return { list: 0, single, filters }
    } else if (cardsCollapse === 'single' || xlDown) {
      return { list: SINGLE_CARDS, single, filters }
    }
    return { list: DOUBLE_CARDS, single, filters }
  }, [cardsCollapse, filtersPinned, lgDown, mdDown, xlDown])

  return sizes
}
